import React from "react";

function SapExtension() {
  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb5">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            SAP Extension Services
          </h4>
        </div>
      </div>

      {/* Body Section Start */}
      <div className="container py-5">
        <section className="wow fadeInUp" data-wow-delay="0.2s">
          <div className="row align-items-center g-5">
            {/* Image Section */}
            <div className="col-lg-6 col-md-12">
              <img
                src="assets/img/sapExtension.jpg"
                alt="SAP Extension Services"
                className="img-fluid rounded-4 shadow-lg"
                style={{
                  width: "100%",
                  height: "100%",
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* Text Section */}
            <div className="col-lg-6 col-md-12">
              <div className="section-title">
                <h2 className="fw-bold text-primary mb-3">
                  Tailor Your SAP System To Your Success
                </h2>
                <p>
                  Our <strong>SAP Extension Services</strong> offer organizations
                  the ability to customize and expand their SAP solutions to meet
                  specific business needs and requirements. The following are
                  benefits associated with this service:
                </p>
                <ul className="list-unstyled ms-3">
                  <li> Creation of tailored SAP Solutions</li>
                  <li> Enhancement of SAP Functionalities</li>
                  <li> Better User Experience on SAP</li>
                  <li> Creation of Optimized SAP Workflows</li>
                  <li> System Adaptability to Business Changes</li>
                  <li> Competitive Advantage through SAP</li>
                  <li> Enhanced Reporting and Analytics</li>
                  <li> Improved User Adoption of SAP</li>
                </ul>
                <p className="mt-3">
                  Our SAP extension services offer you the flexibility to customize
                  and enhance your SAP solutions to better align with unique
                  business processes, industry requirements, and strategic business
                  objectives.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Mobile Image Adjustment */}
      <style>
        {`
          @media (max-width: 768px) {
            img[alt="SAP Extension Services"] {
              max-height: 350px !important;
            }
          }
        `}
      </style>
    </>
  );
}

export default SapExtension;
